import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import purchaseOrderConfig from './config/purchaseOrderConfig';
import setViewTitle from '../../helpers/setViewTitle';
import sendNotification from '../../helpers/sendNotification';
import Widget from '../common/Widget';
import CommentsWidget from '../common/CommentsWidget';
import DocumentsCollection from '../common/DocumentsCollection';
import NeedsClaim from '../common/NeedsClaim';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var PurchaseOrder = createReactClass({

  getInitialState() {
    return {
      hasBeenFound: false,
      order: {
        lines: [],
        newLines: [],
      }
    };
  },

  componentWillMount() {
    setViewTitle('Genehmigte Bestellungen');
  },

  componentDidMount() {
    request.get({
      url: purchaseOrderConfig.apiUrl + this.props.match.params.id,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            hasBeenFound: true,
            order: data
          });
        }
      }
    });
  },

  handleSubmit(e) {
    e.preventDefault();

    var order = this.state.order;

    request.post({
      url: purchaseOrderConfig.apiUrl + 'orderitems',
      data: { id: order.purchaseId, orderId: order.id },
      success: () => {
        sendNotification('Bestellung aufgegeben.');
        this.props.history.push('/purchaseorders/overview');
      }
    });
  },

  handleReject(e) {
    e.preventDefault();

    var order = this.state.order;

    request.post({
      url: purchaseOrderConfig.apiUrl + 'reject',
      data: { id: order.purchaseId, orderId: order.id },
      success: () => {
        sendNotification('Bestellung wurde abgelehnt.');
        this.props.history.push('/purchaseorders/overview');
      }
    });
  },

  enrichNewComment(newComment) {
    newComment.orderId = this.state.order.id;
    return newComment;
  },

  onDocumentDeleted(document) {
    const order = this.state.order;
    const documentIndexToDelete = order.documents.findIndex(x => x.id === document.id);

    if (documentIndexToDelete >= 0) {
      order.documents.splice(documentIndexToDelete, 1);
      this.setState({order});
    }
  },

  onDocumentUploaded(document) {
    const order = this.state.order;
    order.documents.push(document);
    this.setState({order});
  },

  render() {
    if (!this.state.hasBeenFound) {
      return null;
    }

    var displayLines = this.state.order.lines.map(line =>
      <tr key={line.itemId}>
          <td>{line.itemName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    var displayNewLines = this.state.order.newLines.map(line =>
      <tr key={line.itemName}>
          <td>{line.itemName}</td>
          <td>{line.purchaseUnitQuantity}</td>
          <td>{line.purchaseUnitName}</td>
          <td>{line.lineNetPrice}</td>
      </tr>
    );

    const formTitle = this.state.order.orderWithoutStorage ? 'Bestellungsübersicht - Ohne Lagerführung' : 'Bestellungsübersicht';

    const bestellungBody = this.state.order.orderWithoutStorage ? (
      <div style={{ padding: '10px' }}>
        <strong style={{ marginRight: '.5em' }}>Bestellsumme:</strong>
        <span>€ {this.state.order.price}</span>
      </div>
    ) : (
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead>
          <tr>
            <th>Artikel</th>
            <th>Bestellmenge</th>
            <th>Bestelleinheit</th>
            <th>Preis</th>
          </tr>
          </thead>
          <tbody>
          {displayLines}
          {displayNewLines}
          </tbody>
        </table>
      </div>
    );

    return (
      <div>
        <div className="row">
          <Widget title={formTitle} bodyClassName="min-height-auto">
            {bestellungBody}
            <div className="widget-footer">
              <NeedsClaim claim="purchaseorders:write">
                <input type="button" className="btn btn-danger" value="Ablehnen" disabled={this.props.isAjaxInProgress} onClick={this.handleReject}/>
                <input type="button" className="btn btn-primary" value="Bestellen" disabled={this.props.isAjaxInProgress} onClick={this.handleSubmit}/>
              </NeedsClaim>
            </div>

          </Widget>
        </div>
        <div className="row">
          <CommentsWidget
            apiUrl={`purchaseorders/${this.state.order.id}/comments`}
            containerClassName="col-md-12"
            beforeSubmit={newComment => this.enrichNewComment(newComment)}
            claim="purchaseorders:write"
          />
        </div>
        <div className="row">
          <DocumentsCollection
            documents={this.state.order.documents}
            onDoumentDeleted={this.onDocumentDeleted}
            onDocumentUploaded={this.onDocumentUploaded}
            deleteUrlBase={`${purchaseOrderConfig.apiUrl}${this.state.order.id}`}
            viewUrlBase={`${purchaseOrderConfig.apiUrl}${this.state.order.id}`}
            uploadUrlBase={`${purchaseOrderConfig.apiUrl}${this.state.order.id}`}
            claim="purchaseorders:write"
          />
        </div>
      </div>
    );
  }

});

export default AjaxInProgressHOC(PurchaseOrder);



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrder.js